import { AuthMethod, isFailure, sessionStorageProxy } from "@sportal/api";

import {
  NotificationContext,
  Notificator,
} from "../../components/notification";
import { getAuthMethod } from "../../store/info/info.selectors";
import { getBackendUrl, getLogoutUrl } from "../../store/config.selectors";
import { SessionStorageKeys } from "../../services";

export const login =
  (username, password) =>
  async (dispatch, getState, { api }) => {
    dispatch(resetSessionExpired());

    const result = await api.auth.login(username, password);

    if (isFailure(result)) {
      dispatch(loginFailure(result.error));

      return;
    }

    dispatch(resetUser());
    dispatch(loginSuccess());
  };

export const logout =
  () =>
  async (dispatch, getState, { api }) => {
    const state = getState();
    const authMethod = getAuthMethod(state);
    const backendUrl = getBackendUrl(state);
    const logoutUrl = getLogoutUrl(state);

    if (authMethod === AuthMethod.SSO) {
      window.location =
        (backendUrl || "") +
        "/saml/logout?action=" +
        encodeURIComponent(
          window.location.origin + window.location.pathname + "#/login"
        );

      return Promise.resolve();
    }

    if (logoutUrl) {
      window.location = logoutUrl;

      return;
    }

    const result = await api.auth.logout();

    if (isFailure(result)) {
      dispatch(
        Notificator.error("error_during_logout", {
          context: NotificationContext.System,
        })
      );
      dispatch(logoutFailure(result.error));

      return;
    }

    sessionStorageProxy.removeItem(SessionStorageKeys.Reports);
    sessionStorageProxy.removeItem(SessionStorageKeys.IsPromoDismissed);

    dispatch(resetUser());
  };

export const LOGIN_SUCCESS = "[AUTH] LOGIN_SUCCESS";
export const LOGIN_FAILURE = "[AUTH] LOGIN_FAILURE";
export const LOGOUT_FAILURE = "[AUTH] LOGOUT_FAILURE";
export const RESET_USER = "[AUTH] RESET_USER";
export const SET_SESSION_EXPIRED = "[AUTH] SET_SESSION_EXPIRED";
export const RESET_SESSION_EXPIRED = "[AUTH] RESET_SESSION_EXPIRED";

export const loginSuccess = () => {
  return {
    type: LOGIN_SUCCESS,
  };
};
export const loginFailure = (error) => {
  return {
    type: LOGIN_FAILURE,
    payload: error,
  };
};
export const logoutFailure = (error) => ({
  type: LOGOUT_FAILURE,
  payload: error,
});
export const resetUser = () => ({
  type: RESET_USER,
});
export const setSessionExpired = () => ({
  type: SET_SESSION_EXPIRED,
});

const resetSessionExpired = () => ({
  type: RESET_SESSION_EXPIRED,
});
